import styled from "styled-components";
export const MainWindow = styled.div`
  position: fixed;
  top: 25%;
  left: 25%;
  transform: translate(-25%, -25%);
`;
export const MainTable = styled.div`
  position: fixed;
  top: 80%;
  left: 80%;
  transform: translate(-80%, -80%);
`;
